export default __webpack_public_path__ + "static/media/Instagram.93f69e52.png";